import { Controller } from '@hotwired/stimulus';

// Keeps a plan of care's end date picker from offering days before the start date. The Save handler in
// shared/form/_custom_form_new and _custom_form_edit is what blocks an end date before the start date; this only
// greys those days out in the picker. Same-day start and end stays selectable, matching StartEndDateValidator.
//
// The start date input is found the way the Save handler finds it, through the form's data-start-date-id.
export default class extends Controller {
  static values = { floor: String };

  connect() {
    const { form } = this.element;
    const startId = form?.dataset.startDateId;
    this.startInput = startId ? form.querySelector(`[name*="[datum][${startId}][start_date]"]`) : null;
    if (!this.startInput) return;

    this.sync = this.sync.bind(this);
    this.startInput.addEventListener('change', this.sync);
    this.startInput.addEventListener('input', this.sync);
    this.sync();
  }

  disconnect() {
    if (!this.startInput) return;

    this.startInput.removeEventListener('change', this.sync);
    this.startInput.removeEventListener('input', this.sync);
  }

  sync() {
    this.element.min = this.startInput.value || this.floorValue;
  }
}
